var _path, _path2, _path3, _path4, _path5, _circle, _path6, _path7, _path8, _path9, _path10, _circle2, _circle3, _circle4, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _circle5, _ellipse, _circle6, _circle7, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _ellipse2, _ellipse3, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOcCollaboration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1181,
    height: 753,
    viewBox: "0 0 1181 753",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M323.293 58.1435C339.126 70.8102 363.993 98.6435 336.793 108.644C342.126 124.644 343.293 162.944 305.293 188.144L298.06 211.144M258.793 164.144C256.959 170.144 255.593 189.644 262.793 205.644M253.793 210.144C269.459 204.477 299.293 197.544 299.293 217.144V226.144C326 205.644 352 182.144 372 161.644",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M308.793 148.144C308.293 151.144 309.593 157.344 318.793 158.144",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M335.793 86.6435C335.793 92.2477 334.137 97.2197 331.584 100.729C329.03 104.242 325.714 106.144 322.293 106.144C318.871 106.144 315.555 104.242 313.001 100.729C310.448 97.2197 308.793 92.2477 308.793 86.6435C308.793 81.0394 310.448 76.0674 313.001 72.5576C315.555 69.0454 318.871 67.1435 322.293 67.1435C325.714 67.1435 329.03 69.0454 331.584 72.5576C334.137 76.0674 335.793 81.0394 335.793 86.6435Z",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M277.293 101.644L308.293 91.6435",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M300.793 81.1435C301.626 77.8102 304.693 70.1435 310.293 66.1435",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 323.793,
    cy: 86.1435,
    r: 3.5,
    fill: "#21325B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M254.046 209.909L138.018 346.051M138.018 346.051C136.336 351.056 134.667 362.729 148.793 377.144M138.018 346.051C146.594 344.883 168.891 345.45 189.474 357.062C215.202 371.577 242.443 397.104 310.042 419.627M310.042 419.627L287.341 435.644M310.042 419.627C308.192 399.773 306.712 355.961 315.591 339.544C324.469 323.127 333 299.644 339 290.144C361.5 258.144 359.5 264.144 393 218.644",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M221.293 247.144C202.626 262.644 155.293 295.344 115.293 302.144C105.959 305.977 89.8925 316.744 100.293 329.144C110.693 341.544 117.626 356.644 119.793 362.644C121.459 368.144 127.293 374.744 137.293 357.144",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M107.292 337.644C99.4591 342.144 81.1925 350.744 70.7925 349.144C60.3925 347.544 53.4592 351.81 51.2925 354.144C50.1258 355.977 49.3925 359.744 55.7925 360.144C62.1925 360.544 69.7925 360.31 72.7925 360.144M81.2925 354.144C77.7925 357.81 65.8925 366.144 46.2925 370.144C42.4591 370.81 37.2925 374.644 44.2925 379.144C50.2925 382.644 66.8925 379.444 75.2925 374.644C68.7925 377.81 57.0925 386.244 62.2925 394.644C63.9591 396.31 70.9925 396.444 85.7925 383.644M85.7925 383.644L96.7925 374.644M85.7925 383.644C82.6258 391.81 77.7925 411.644 90.7925 400.644C100.292 391.144 98.2925 383.044 102.292 380.644C106.292 378.244 115.292 368.977 119.292 364.644M96.7925 358.144C95.6258 362.477 94.6925 372.544 100.292 378.144",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M164.793 348.644C158.459 366.644 128.793 403.644 102.293 450.144C84.626 479.31 42.4926 544.444 15.2926 571.644C11.6259 576.81 8.19261 588.544 23.7926 594.144C35.7926 599.144 41.1926 610.744 42.7926 623.144C44.7926 638.644 70.2926 650.144 87.2926 638.644C100.843 629.477 139.805 563.452 169.239 526.144M189.293 504.644C183.61 509.007 176.733 516.644 169.239 526.144M169.239 526.144L135.793 700.644M135.793 700.644C139.257 705.977 150.796 716.044 169.239 713.644M135.793 700.644C152.793 696.144 199.493 687.644 228.293 687.644",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M217.293 694.644C223.626 692.977 236.393 684.544 236.793 664.144C237.193 643.744 245.626 608.644 249.793 593.644L290.793 413.644",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 304.793,
    cy: 118.144,
    r: 1.5,
    fill: "#21325B"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 310.793,
    cy: 126.144,
    r: 1.5,
    fill: "#21325B"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 295.793,
    cy: 129.144,
    r: 1.5,
    fill: "#21325B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M454.5 72.1436C454.5 89.9226 440.741 104.144 424 104.144C407.259 104.144 393.5 89.9226 393.5 72.1436C393.5 54.3645 407.259 40.1436 424 40.1436C440.741 40.1436 454.5 54.3645 454.5 72.1436Z",
    stroke: "#21325B",
    strokeWidth: 5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M414 70.5L422.5 79",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M422.5 79L435 64",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M148.793 105.644C173.193 60.0435 209.626 54.3102 224.793 57.1435C256.293 8.64352 299.793 -7.35647 326.293 7.14353C347.493 18.7435 330.126 47.9769 318.793 61.1435L307.793 45.1435C300.193 59.9435 278.459 54.4769 267.793 51.1435C276.959 70.4769 291.593 120.444 260.793 165.644C229.993 210.844 191.293 211.644 171.793 198.644C153.793 185.81 124.393 151.244 148.793 105.644Z",
    fill: "#21325B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5964 682.72C-13.2074 635.144 8.85851 603.484 20.7926 595.644C39.2926 601.644 39.7926 621.644 42.7926 631.144L35.8686 650.692C31.2354 659.1 33.9381 675.547 35.8686 682.72C43.8715 715.949 31.7926 719.144 25.865 710.244L10.5964 682.72Z",
    fill: "#21325B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M237.293 727.144C174.493 735.544 161.459 711.31 162.793 697.144C173.593 692.744 203.293 691.144 217.293 690.144C213.293 699.344 218.293 698.144 221.793 700.644C226.293 703.644 238.793 707.31 245.793 707.644C277.293 709.144 252.626 724.977 237.293 727.144Z",
    fill: "#21325B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M372 161.644C380.5 169.644 396.2 192.244 393 218.644",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M374.5 160.644C378.5 154.977 386.5 142.644 382.5 131.644C381.238 127.647 380.662 118.767 383.5 114.144C387.409 107.776 395.552 107.085 397 116.644L398 127.644M390.5 141.144C397 130.81 412 109.344 420 106.144C428 102.944 429.333 106.144 429 108.144M429 108.144C423.667 113.81 412.5 127.344 410.5 136.144M429 108.144C434 103.644 444.4 96.3435 446 103.144C447 109.644 430.8 121.044 424 132.644M438.5 115.363C443.667 114.53 447.5 120.644 438.5 133.644L436.24 137.144M423 157.644L436.24 137.144M436.24 137.144C440.319 137.644 446.031 142.644 436.24 158.644C428.993 169.144 410.6 193.944 395 209.144",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M358 15.6436C367.167 43.1436 381.8 105.444 367 134.644C366 135.81 367.5 137.944 381.5 137.144",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M358 15.6436C389 14.4769 457.1 10.2436 481.5 2.64355",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M482 3.14355C484.167 36.9769 487.2 108.144 482 122.144",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M440.5 135.644C452.667 135.31 477.6 132.544 482 122.144",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M654 198.643C635.6 195.443 639.667 177.643 644 169.143C668 165.143 661.5 140.143 654 147.143C648 152.743 642.5 151.477 640.5 150.143C631.7 146.143 639.167 133.477 644 127.643L631.5 109.643C627 110.31 616.1 106.443 608.5 85.6435C600.9 64.8435 616 53.6435 624.5 50.6435C633.667 48.3101 658.8 49.8435 686 74.6435C713.2 99.4435 708.333 133.31 702.5 147.143C694 165.643 672.4 201.843 654 198.643Z",
    fill: "#21325B"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M633.5 111.643C617.5 123.643 586.2 155.843 589 188.643C590.333 196.31 598 213.643 618 221.643C620 221.81 623.9 223.443 623.5 228.643M657 198.643C653.167 202.643 648.6 212.143 651 222.143",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M612.5 131.643C601 136.31 581.3 147.843 594.5 156.643",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M625 124.643C627.167 126.31 631.1 131.243 629.5 137.643",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M646 154.143C646.667 156.477 646.6 161.043 641 160.643",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M590.5 179.643C593.333 178.643 599.3 175.343 600.5 170.143",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 625,
    cy: 159.643,
    r: 2,
    fill: "#21325B"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 619.757,
    cy: 136.877,
    rx: 2.5,
    ry: 3.5,
    transform: "rotate(25.3369 619.757 136.877)",
    fill: "#21325B"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 616,
    cy: 169.643,
    r: 2,
    fill: "#21325B"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 627,
    cy: 176.643,
    r: 2,
    fill: "#21325B"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M701.5 353.143C693.9 371.143 663.333 368.643 649 365.143L643.5 363.143V369.143L653.5 371.143C658.833 372.81 669.7 379.643 670.5 393.643C671.5 411.143 667 458.143 665 470.643C663.4 480.643 655.667 484.477 652 485.143C646.4 495.943 624 492.977 613.5 490.143C612.7 497.743 605.833 496.977 602.5 495.643C602.1 498.443 598 498.477 596 498.143C583.6 548.543 586.5 640.81 589.5 680.643C588.833 691.477 592.3 712.543 611.5 710.143C630.7 707.743 664.5 711.143 679 713.143C702.6 717.543 710.167 702.643 711 694.643C730.2 701.443 741.333 693.81 744.5 689.143C738.9 523.143 713.5 395.977 701.5 353.143Z",
    fill: "#21325B"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M646.5 710.143C646.5 712.31 646 717.043 644 718.643C641.5 720.643 596.5 715.643 597.5 738.143C597 741.31 602 746.143 614 747.643C630.879 749.753 679.26 755.913 690.861 734.643M697 711.643L692.5 730.643C692.087 732.074 691.537 733.405 690.861 734.643M726.5 697.143C728.574 710.977 724.35 737.843 690.861 734.643",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M671 248.643C712 267.643 788.3 360.743 715.5 407.143",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M700 358.643C695 332.477 683.4 270.243 669 250.643C668.167 239.143 663.4 217.343 651 222.143C638.5 222.477 613.5 228.243 613.5 248.643V266.143M633 250.643C616 259.31 579.7 303.843 570.5 412.643C569.833 425.643 575.7 451.643 604.5 451.643C633.3 451.643 644.5 374.143 648 335.643",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M584 447.643C583.5 454.81 580.6 469.843 573 472.643C563.5 476.143 571.5 490.143 576.5 493.643M576.5 472.643C575.333 480.643 575.9 496.643 587.5 496.643M587.5 480.643C586.5 485.977 587.4 496.643 599 496.643M599 480.643C597.5 486.81 597.4 498.343 609 495.143M614 455.143C611.667 463.477 608.2 481.643 613 487.643",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M574 368.644C558.167 368.31 525.5 370.044 521.5 379.644C517.5 389.244 511.167 416.977 508.5 429.643C505 446.643 504.2 481.443 529 484.643C553.8 487.843 567.5 488.643 570.5 488.643",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M614 489.143C624.833 492.977 647.8 496.143 653 478.143C658.2 460.143 660.833 414.643 661.5 394.143C661.833 388.31 658.8 376.243 644 374.643M575.5 358.643C563.667 357.477 539.3 358.243 536.5 370.643M645.5 369.143C655.333 369.643 672 372.643 670.5 404.143C668.892 437.906 669 486.643 650.5 485.143",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M983.5 35.6436L961 79.1436",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M941 147.144C940.5 148.81 940.3 153.144 941.5 155.144",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M941.5 155.144H936",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M900.5 197.644C896.167 191.144 887.6 176.344 888 169.144C887.667 166.81 887.8 162.144 891 162.144C894.2 162.144 895.333 166.81 895.5 169.144",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M969 357.644C931 333.144 919.5 286.644 910.5 254.644C906.315 237.644 896.1 215.144 912.5 193.144C928.9 171.144 944 186.977 949.5 197.644L997.5 277.644M969 329.144C955.333 355.644 952 406.144 969 443.644M988.5 285.144C992.167 274.31 1003.9 253.644 1021.5 257.644C1039.1 261.644 1049.83 243.977 1053 234.644M1057.5 395.144C1067 420.977 1094.7 461.844 1129.5 418.644C1164.3 375.444 1112.67 286.977 1082.5 248.144",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M1056.5 394.644C1070.17 397.31 1100.3 398.144 1111.5 380.144",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M1053 234.644C1058 232.31 1069.2 233.244 1082 247.644",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M996 443.644L976 350.144C973.5 339.144 978.4 316.944 1018 316.144C1028.33 315.81 1048 309.144 1057.5 302.144C1066.84 295.262 1082 297.644 1083.5 307.644L1101.5 386.144",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M1055 394.144C1043.33 391.31 1022.6 388.644 1033 400.644C1043.4 412.644 1026.33 408.644 1016.5 405.144C1012.5 403.644 1004.5 402.044 1004.5 407.644C1004.5 409.571 1006.51 411.316 1009.5 412.831M1030 418.644C1024.42 417.769 1015.19 415.719 1009.5 412.831M1009.5 412.831C1005.89 414.648 1003.47 418.464 1012.67 422.644M1032 428.144C1022.81 426.331 1016.65 424.453 1012.67 422.644M1012.67 422.644C1009.75 425.379 1008.61 430.695 1022 433.62M1033 435.144C1028.55 434.785 1024.93 434.259 1022 433.62M1022 433.62C1022.83 438.628 1030 446.744 1052 439.144C1074 431.544 1077.83 428.644 1077 428.144",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M1028 666.144C979.2 656.944 966.667 511.977 966.5 440.644C991.7 447.844 1013.33 438.644 1021 433.144C1026.6 451.544 1060.67 438.477 1077 429.644C1093 446.144 1110.5 436.977 1117.5 429.644L1175 580.144C1180.17 596.477 1182.5 635.144 1150.5 659.144C1118.5 683.144 1102.83 654.477 1099 637.144C1095.67 650.644 1076.8 675.344 1028 666.144Z",
    fill: "#21325B"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M1044.5 666.644C1048 673.644 1048.11 686.813 1039 693.644C1029 701.144 1020.67 709.644 1017 716.144C1015.17 720.977 1016.7 729.644 1037.5 725.644C1058.3 721.644 1075.17 710.977 1081 706.144C1084 703.477 1088.7 695.244 1083.5 683.644C1078.3 672.044 1075.67 664.81 1075 662.644",
    stroke: "#21325B",
    strokeWidth: 5
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M1146 663.498C1150.21 681.869 1160.75 720.546 1169.23 722.479C1177.71 724.413 1178.49 708.782 1177.81 700.724C1176.97 689.282 1173.37 660.501 1165.69 644.644",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M1097.5 129.644C1131.5 166.844 1104.67 226.81 1087 252.144C1072.2 231.744 1057.5 231.31 1052 233.644L1044.5 219.644C1054.1 211.644 1060.83 193.644 1063 185.644C1067.83 188.31 1077.5 189.544 1077.5 173.144C1077.5 156.744 1069.17 162.31 1065 167.144L1049.5 171.144C1051.5 147.144 1031 135.81 1020.5 133.144C1019.83 142.144 1012.19 166.191 975 165.144C939.5 164.144 935.5 131.144 936.5 114.644C939.276 68.8504 982.167 78.1436 995 91.1436C1020.5 66.1436 1054 92.6436 1061.5 111.144C1075.9 109.944 1091.5 122.977 1097.5 129.644Z",
    fill: "#21325B"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M969 228.644C963.8 218.244 970.167 210.31 974 207.644C987.2 232.844 1009.83 237.144 1019.5 236.144V257.644C1007.1 255.644 997.333 266.477 994 272.144C987.833 261.977 974.2 239.044 969 228.644Z",
    fill: "#21325B"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M963.5 159.644C962.5 186.977 973.9 240.444 1027.5 235.644C1037 234.144 1041.5 230.644 1046.5 221.144",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M1007.5 220.144C1009.67 222.31 1016.1 225.144 1024.5 219.144",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M1008.5 188.644C1005.33 196.477 1002.5 211.244 1016.5 207.644",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M1068 170.144C1069.83 171.477 1072.4 175.044 1068 178.644",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M1023.5 174.644C1026.17 173.31 1032.5 171.644 1036.5 175.644",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M978.5 178.644C980.667 177.144 986.1 175.444 990.5 180.644",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M999.5 180.644C999.5 190.563 992.319 198.144 984 198.144C975.681 198.144 968.5 190.563 968.5 180.644C968.5 170.724 975.681 163.144 984 163.144C992.319 163.144 999.5 170.724 999.5 180.644Z",
    stroke: "#21325B",
    strokeWidth: 5
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M1046.5 176.644C1046.5 187.906 1039.11 196.144 1031 196.144C1022.89 196.144 1015.5 187.906 1015.5 176.644C1015.5 165.382 1022.89 157.144 1031 157.144C1039.11 157.144 1046.5 165.382 1046.5 176.644Z",
    stroke: "#21325B",
    strokeWidth: 5
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 984.5,
    cy: 193.644,
    rx: 5.5,
    ry: 4,
    fill: "#21325B"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1030.5,
    cy: 190.644,
    rx: 5.5,
    ry: 4,
    fill: "#21325B"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M999.5 178.144C1002.83 176.977 1010.5 175.244 1014.5 177.644",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M866.5 34.6436C852.167 63.8102 827 128.644 841 154.644",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M866.5 34.6435C898.667 30.3102 967.1 24.4435 983.5 35.6435",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M882 64.6435C893.5 62.8102 920.7 60.2435 937.5 64.6435M875 86.6436L932 83.6436M872 105.644L919 101.644M872 124.144H901.5",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M894.5 163.144C895.667 157.81 897.3 145.244 894.5 137.644C891.7 130.044 895.667 127.477 898 127.144C900.5 126.81 905.3 129.244 904.5 141.644",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M902 129.144C900.833 122.977 900.4 110.544 908 110.144C916.8 112.144 917.667 133.31 917 143.644",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M915.5 119.644C919.394 118.704 925.034 120.316 926.215 131.644M926 141.644C926.467 137.677 926.5 134.377 926.215 131.644M926.215 131.644C929.31 128.977 935.2 127.244 934 141.644C932.5 159.644 931 157.644 935 181.644",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M1097.5 592.144C1095.33 605.31 1094.4 636.744 1108 657.144",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M841 154.644C852.167 155.977 878.6 158.844 895 155.644",
    stroke: "#21325B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOcCollaboration);
export default __webpack_public_path__ + "static/media/oc-collaboration.fd3e0709b6be8beaf18fa08cd9d64adc.svg";
export { ForwardRef as ReactComponent };